export const enSolutions = {
    "our": "OUR",
    "title": "SOLUTIONS",
    "subTitle": "DIGITAL SOLUTIONS TAILORED TO YOUR NEEDS",
    "description": "Transform your business with our comprehensive suite of industry-leading SaaS platforms. From multi-vendor e-commerce marketplaces to intelligent learning management systems, food delivery networks to enterprise HR solutions - we deliver scalable, cloud-native applications that drive digital transformation. Each solution is built with cutting-edge microservices architecture, ensuring maximum performance, security, and adaptability for businesses of all sizes.",
    "verticals": {
        "solution1": { "title": "SaaS Billing System" },
        "solution2": { "title": "Human Resource Management System" },
        "solution3": { "title": "Point Of Sale System" },
        "solution4": { "title": "E-Commerce Multi-Vendor Marketplace" },
        "solution5": { "title": "Taxi Solution" },
        "solution6": { "title": "Learning Management System" },
        "solution7": { "title": "Food Delivery Marketplace" },
        "solution8": { "title": "Service Booking Platform" }
    }
}

export const frSolutions = {
    "our": "NOS",
    "title": "SOLUTIONS",
    "subTitle": "SOLUTIONS NUMÉRIQUES ADAPTÉES À VOS BESOINS",
    "description": "Transformez votre entreprise avec notre suite complète de plateformes SaaS leaders du marché. Des marketplaces e-commerce multi-vendeurs aux systèmes de gestion d'apprentissage intelligents, des réseaux de livraison de nourriture aux solutions RH d'entreprise - nous livrons des applications évolutives et natives du cloud qui propulsent la transformation digitale. Chaque solution est construite avec une architecture microservices de pointe, garantissant performance maximale, sécurité et adaptabilité pour les entreprises de toutes tailles.",
    "verticals": {
        "solution1": { "title": "Système de Facturation SaaS" },
        "solution2": { "title": "Système de Gestion des Ressources Humaines" },
        "solution3": { "title": "Système de Point de Vente" },
        "solution4": { "title": "Marketplace E-Commerce Multi-Vendeurs" },
        "solution5": { "title": "Solution de Taxi" },
        "solution6": { "title": "Système de Gestion de l'Apprentissage" },
        "solution7": { "title": "Marketplace de Livraison de Nourriture" },
        "solution8": { "title": "Plateforme de Réservation de Services" }
    }
}

export const nlSolutions = {
    "our": "ONZE",
    "title": "OPLOSSINGEN",
    "subTitle": "DIGITALE OPLOSSINGEN OP MAAT VAN UW BEHOEFTEN",
    "description": "Transformeer uw bedrijf met onze uitgebreide suite van toonaangevende SaaS-platforms. Van multi-vendor e-commerce marktplaatsen tot intelligente leerbeheersystemen, food delivery netwerken tot HR-oplossingen voor bedrijven - wij leveren schaalbare, cloud-native applicaties die digitale transformatie stimuleren. Elke oplossing is gebouwd met geavanceerde microservices-architectuur, wat maximale prestaties, veiligheid en flexibiliteit garandeert voor bedrijven van elke omvang.",
    "verticals": {
        "solution1": { "title": "SaaS Facturatiesysteem" },
        "solution2": { "title": "Human Resource Management Systeem" },
        "solution3": { "title": "Point Of Sale Systeem" },
        "solution4": { "title": "E-Commerce Multi-Vendor Marktplaats" },
        "solution5": { "title": "Taxi Oplossing" },
        "solution6": { "title": "Leerbeheersysteem" },
        "solution7": { "title": "Food Delivery Marktplaats" },
        "solution8": { "title": "Serviceboekingsplatform" }
    }
}

export const deSolutions = {
    "our": "UNSERE",
    "title": "LÖSUNGEN",
    "subTitle": "DIGITALE LÖSUNGEN FÜR IHRE BEDÜRFNISSE",
    "description": "Transformieren Sie Ihr Unternehmen mit unserer umfassenden Suite branchenführender SaaS-Plattformen. Von Multi-Vendor-E-Commerce-Marktplätzen über intelligente Lernmanagementsysteme, Food-Delivery-Netzwerke bis hin zu HR-Lösungen für Unternehmen – wir liefern skalierbare, cloud-native Anwendungen, die die digitale Transformation vorantreiben. Jede Lösung ist mit modernster Microservices-Architektur gebaut und gewährleistet maximale Leistung, Sicherheit und Anpassungsfähigkeit für Unternehmen jeder Größe.",
    "verticals": {
        "solution1": { "title": "SaaS-Abrechnungssystem" },
        "solution2": { "title": "Personalmanagementsystem" },
        "solution3": { "title": "Point-of-Sale-System" },
        "solution4": { "title": "E-Commerce Multi-Vendor Marktplatz" },
        "solution5": { "title": "Taxi-Lösung" },
        "solution6": { "title": "Lernmanagementsystem" },
        "solution7": { "title": "Food-Delivery-Marktplatz" },
        "solution8": { "title": "Servicebuchungsplattform" }
    }
}